import { RoutineTriggerConfig, RoutineType } from '@gripp/shared-logic';
import { useMemo } from 'react';
import { RoutineTrigger } from './routineTrigger';

type DefaultRoutineTriggerProps = {
  workspaceRoutineId: string;
  control: any;
  name?: string;
  type: RoutineType;
};

export const DefaultRoutineTrigger = (props: DefaultRoutineTriggerProps) => {
  const i18nPrefix = 'alerts.trigger.default';
  const fieldName = props.name ?? 'config';

  const InitConfig = useMemo(
    () => ({
      workspaceRoutineId: props.workspaceRoutineId,
      onCompletionCount: undefined,
      daysSinceCompleted: undefined,
      every: undefined,
      routineType: props.type,
    }),
    [props.workspaceRoutineId, props.type]
  );

  props.control.register(fieldName, {
    value: InitConfig,
  });

  return (
    <RoutineTrigger<RoutineTriggerConfig>
      initConfig={InitConfig}
      control={props.control}
      name={fieldName}
      i18nPrefix={i18nPrefix}
    />
  );
};
